/**
 * Full builder payload stored in checkout_json (backend treats as opaque).
 * `version` allows future migrations when deserializing.
 * Payment provider settings are loaded from a separate API, not persisted here.
 */

export const CHECKOUT_JSON_VERSION = 1;

export const mergeParsedCheckoutState = (parsed, initialState) => {
  if (!parsed || typeof parsed !== 'object') {
    return { ...initialState };
  }
  const {
    productType = initialState.productType,
    product: savedProduct,
    businessInfo: savedBusiness,
    productId = initialState.productId,
    isProductCreated = initialState.isProductCreated,
    checkoutPageId = initialState.checkoutPageId,
    app_instance_id: savedAppInstanceIdSnake,
    appInstanceId: savedAppInstanceIdCamel,
  } = parsed;

  const appInstanceId =
    savedAppInstanceIdSnake != null
      ? savedAppInstanceIdSnake
      : savedAppInstanceIdCamel != null
        ? savedAppInstanceIdCamel
        : initialState.appInstanceId;

  return {
    productType,
    product: { ...initialState.product, ...(savedProduct || {}) },
    businessInfo: { ...initialState.businessInfo, ...(savedBusiness || {}) },
    productId,
    isProductCreated,
    checkoutPageId,
    appInstanceId,
  };
};

export const parseCheckoutJsonString = (checkoutJson, initialState) => {
  if (!checkoutJson || typeof checkoutJson !== 'string' || !checkoutJson.trim()) {
    return { ...initialState };
  }
  try {
    const parsed = JSON.parse(checkoutJson);
    return mergeParsedCheckoutState(parsed, initialState);
  } catch {
    return { ...initialState };
  }
};

export const serializeCheckoutStateForApi = (state) =>
  JSON.stringify({
    version: CHECKOUT_JSON_VERSION,
    productType: state.productType,
    product: state.product,
    businessInfo: state.businessInfo,
    productId: state.productId,
    isProductCreated: state.isProductCreated,
    checkoutPageId: state.checkoutPageId ?? null,
    app_instance_id: state.appInstanceId ?? null,
  });
